import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Menu, X, Globe, Phone, Mail, ClipboardCheck, Sun, Moon, ChevronUp } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';
import './Header.css';

const Header = ({ isMenuOpen, setIsMenuOpen, scrollY, scrollToSection, currentLanguage, changeLanguage }) => {
  const { t } = useTranslation();
  const { theme, toggleTheme } = useTheme();
  const [showAnnouncement, setShowAnnouncement] = useState(true);

  const scrollProgress = typeof window !== 'undefined'
    ? Math.min((scrollY / Math.max(document.documentElement.scrollHeight - window.innerHeight, 1)) * 100, 100)
    : 0;

  return (
    <>
      {showAnnouncement && (
        <div className="announcement">
          <div className="ann-ticker-wrap" aria-hidden="true">
            <div className="ann-ticker-track">
              <span className="ann-item"><span className="ann-dot" />Engineering & qualification for regulated AM</span>
              <span className="ann-sep">·</span>
              <span className="ann-item ann-en">Free obsolescence screen</span>
              <span className="ann-sep">·</span>
              <span className="ann-item">Partner-fulfilled supply</span>
              <span className="ann-sep">·</span>
              <span className="ann-item ann-en">Published rate card · Net 30</span>
              <span className="ann-sep">·</span>
              <span className="ann-item"><span className="ann-dot" />Engineering & qualification for regulated AM</span>
              <span className="ann-sep">·</span>
              <span className="ann-item ann-en">Free obsolescence screen</span>
              <span className="ann-sep">·</span>
              <span className="ann-item">Partner-fulfilled supply</span>
              <span className="ann-sep">·</span>
              <span className="ann-item ann-en">Published rate card · Net 30</span>
              <span className="ann-sep">·</span>
            </div>
          </div>
          <button onClick={() => setShowAnnouncement(false)} className="announcement-close" aria-label="Close">
            <X size={13} />
          </button>
        </div>
      )}

      <header className={`header ${scrollY > 50 ? 'scrolled' : ''} ${!showAnnouncement ? 'no-announcement' : ''} ${isMenuOpen ? 'menu-open' : ''}`}>
        <div className="header-progress" style={{ width: `${scrollProgress}%` }} />

        <div className="header-inner">
          <div className="header-logo" onClick={() => scrollToSection('hero')}>
            <img src="/logos/meccaflex-isometric-logo.svg" alt="MeccaFlex" />
          </div>

          <nav className={`header-nav ${isMenuOpen ? 'open' : ''}`}>
            <button onClick={() => { scrollToSection('come-funziona'); setIsMenuOpen(false); }}>
              <span className="nav-indicator" aria-hidden="true" />
              {t('nav.howItWorks')}
            </button>
            <button onClick={() => { scrollToSection('servizi'); setIsMenuOpen(false); }}>
              <span className="nav-indicator" aria-hidden="true" />
              {t('nav.services')}
            </button>
            <button onClick={() => { scrollToSection('rate-card'); setIsMenuOpen(false); }}>
              <span className="nav-indicator" aria-hidden="true" />
              {t('nav.rates')}
            </button>
            <button onClick={() => { scrollToSection('problema'); setIsMenuOpen(false); }}>
              <span className="nav-indicator" aria-hidden="true" />
              {t('nav.whyUs')}
            </button>

            <div className="header-nav-mobile">
              <div className="drawer-logo">
                <img src="/logos/meccaflex-isometric-logo.svg" alt="MeccaFlex" />
              </div>
              <a href="mailto:info@meccaflex.com" className="drawer-cta-whatsapp">
                <Mail size={16} />
                Email
              </a>
              <button className="drawer-cta-quote" onClick={() => { scrollToSection('contact'); setIsMenuOpen(false); }}>
                <ClipboardCheck size={15} />
                {t('nav.quote')}
              </button>
              <div className="drawer-contacts">
                <a href="tel:+393401234567"><Phone size={14} />+39 340 123 4567</a>
                <a href="mailto:info@meccaflex.com"><Mail size={14} />info@meccaflex.com</a>
              </div>
            </div>
          </nav>

          <div className="header-actions">
            <button className="header-theme" onClick={toggleTheme} aria-label="Toggle theme">
              {theme === 'dark' ? <Sun size={15} /> : <Moon size={15} />}
            </button>

            <button className="header-lang" onClick={() => changeLanguage(currentLanguage === 'it' ? 'en' : 'it')}>
              <Globe size={14} />
              <span>{currentLanguage === 'it' ? 'EN' : 'IT'}</span>
            </button>

            <span className="header-divider" aria-hidden="true" />

            <button onClick={() => scrollToSection('contact')} className="header-cta">
              <span className="hcta-text">{t('nav.quote')}</span>
            </button>

            <button className="header-toggle" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label="Menu">
              {isMenuOpen ? <X size={20} /> : <Menu size={20} />}
            </button>
          </div>
        </div>
      </header>

      {isMenuOpen && <div className="header-overlay" onClick={() => setIsMenuOpen(false)} />}

      <div className="floating-btns">
        <a
          href="mailto:info@meccaflex.com"
          className="float-btn float-whatsapp"
          aria-label="Email"
        >
          <span className="float-ring" aria-hidden="true" />
          <Mail size={22} />
        </a>

        {scrollY > 600 && (
          <button className="float-btn float-cta" onClick={() => scrollToSection('contact')} aria-label="Free screen">
            <ClipboardCheck size={20} />
          </button>
        )}

        {scrollY > 1000 && (
          <button className="float-btn float-top" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} aria-label="Top">
            <ChevronUp size={22} />
          </button>
        )}
      </div>
    </>
  );
};

export default Header;
